import { connect } from 'react-redux';
import { ConsumerHeader } from '../../../../components/ConsumerHeader';

const mapStateToProps = (state: any) => ({
    isUsingCurrentLocation: state?.location?.isUsingCurrentLocation,
    searchQuery: state?.search?.eventSearch?.q,
    currentPlace: state?.location?.currentPlace,
});

const ConnectedConsumerHeader = connect(mapStateToProps)(ConsumerHeader);

export default ConnectedConsumerHeader;
